import { GridPinnedRowsProp } from '@mui/x-data-grid-pro';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';

import { AvailabilityDataGridRow } from './UserAvailabilityWidget.dataGrid';

export interface UseAvailabilitySummaryProps {
  data?: AvailabilityDataGridRow[] | null;
  columns: { weekStart: Date; weekEnd: Date }[];
}

export const useAvailabilitySummary = ({
  data,
  columns,
}: UseAvailabilitySummaryProps): GridPinnedRowsProp<AvailabilityDataGridRow> => {
  const { t } = useTranslation(I18nNamespace.widgets, { keyPrefix: 'UserAvailabilityWidget' });
  return useMemo(() => {
    const row: AvailabilityDataGridRow = {
      id: 'summary',
      user: {
        id: '',
        firstName: '',
        lastName: t('summary'),
        email: null,
        pictureId: null,
        workingHours: null,
      },
      availabilityPerWeek: columns.map(({ weekStart }, index) => {
        const availabilityAccumulated =
          data?.reduce((acc, row) => {
            return acc + row.availabilityPerWeek[index].availability;
          }, 0) ?? 0;
        return {
          availability: availabilityAccumulated / (data?.length || 1),
          weekStart,
        };
      }),
    };
    return { bottom: [row] };
  }, [data, columns, t]);
};
